import type { AdminFeatureKey, FeatureAccessLevel } from '../permissions/adminFeatures'
import type { AdminActionKey } from '../permissions/adminActions'

export enum UserRole {
  SUPERUSER = 'SUPERUSER',
  CREDIBILA_ADMIN = 'CREDIBILA_ADMIN',
  CREDIBILA_DEV = 'CREDIBILA_DEV',
}

export interface User {
  email: string
  password: string
  role?: UserRole
}

export interface GbcUserState {
  authToken: string
  email: string
  userId: number
  role: UserRole
  isEmailVerified: boolean
  permissions: Record<AdminFeatureKey, FeatureAccessLevel>
  /** Allow/deny for sensitive admin buttons (not read/write). */
  actionGrants: Record<AdminActionKey, boolean>
}

export enum Verification {
  verifyEmail = 'verify-email',
  resetPassword = 'reset-password',
}
